import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class MetricTableModel extends BaseModel {
  static urlPath = "metric-tables";

  @attr("number") next;
  @attr("number") previous;
  @attr("string") endDate;
  @attr("string") startDate;
  @attr("array") reports;
}
